/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-useless-concat */
/* eslint-disable max-len */
/* eslint-disable no-void */
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable object-curly-newline */
import React from "react";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import SompoTextField from "../../../component/textField/SompoTextField";
import { useScreenSize } from "../../../component/Theme";

export interface PasswordValues {
    password: string;
    rePassword: string;
}

interface ChangePasswordModalProps {
    open: boolean;
    values: PasswordValues;
    handleChange: React.ChangeEventHandler<HTMLInputElement>;
    handleClose: React.MouseEventHandler<HTMLButtonElement>;
    register: React.MouseEventHandler<HTMLButtonElement>;
}

const ChangePasswordModal = (props: ChangePasswordModalProps) => {
    const theme = useTheme();
    const { desktop } = useScreenSize();
    const { open, values, handleChange, handleClose, register } = props;

    const formLabelStyle = {
        fontWeight: 700,
        fontSize: "14px",
        letterSpacing: "1px",
        paddingLeft: "5px",
    };

    const changePasswordButtonActive = values.password !== "" && values.rePassword !== "";

    return (
        <Modal
            open={open}
            onClose={handleClose}
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Grid
                container
                direction="column"
                alignItems="center"
                flexWrap="nowrap"
                sx={{
                    width: desktop ? "60%" : "100%",
                    minWidth: desktop ? "400px" : "auto",
                    height: desktop ? "auto" : "100%",
                    p: 5,
                    overflowY: desktop ? "none" : "scroll", // スマホ横向き対応
                    borderRadius: desktop ? "10px" : "0px",
                    bgcolor: "background.paper",
                    outline: "none",
                }}
            >
                <Grid item sx={{ mb: 5 }}>
                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: "20px",
                        }}
                    >
                        パスワード変更
                    </Typography>
                </Grid>
                <Grid item sx={{ backgroundColor: "transparent", width: "80%" }}>
                    <SompoTextField
                        fullWidth
                        label={<Typography sx={formLabelStyle}>新しいパスワード</Typography>}
                        onChange={handleChange}
                        type="password"
                        name="password"
                        value={values.password}
                        sx={{ size: { sm: "small", md: "medium" }, m: 1 }}
                    />
                    <SompoTextField
                        fullWidth
                        label={<Typography sx={formLabelStyle}>新しいパスワード(再入力)</Typography>}
                        onChange={handleChange}
                        type="password"
                        name="rePassword"
                        value={values.rePassword}
                        sx={{ size: { sm: "small", md: "medium" }, m: 1 }}
                    />
                </Grid>
                <Grid item>
                    <Button
                        disabled={!changePasswordButtonActive}
                        sx={{
                            backgroundColor: changePasswordButtonActive ? theme.palette.primary.main : "#ddd",
                            height: { sm: 40, md: 45 },
                            transition: "all 0.2s ease-in-out",
                            "&: hover": {
                                backgroundColor: theme.palette.primary.main,
                                opacity: 0.7,
                            },
                        }}
                        onClick={register}
                    >
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: "14px",
                                letterSpacing: "1px",
                                ml: 3,
                                mr: 3,
                                color: changePasswordButtonActive ? "#fefefe" : "#F3F3F4",
                            }}
                        >
                            変更
                        </Typography>
                    </Button>

                    <Button
                        sx={{
                            height: { sm: 40, md: 45 },
                            marginLeft: "10px",
                            border: "1px solid #ddd",
                        }}
                        onClick={handleClose}
                    >
                        <Typography
                            sx={{
                                fontWeight: 700,
                                fontSize: "14px",
                                letterSpacing: "1px",
                                color: "#333",
                            }}
                        >
                            キャンセル
                        </Typography>
                    </Button>
                </Grid>
            </Grid>
        </Modal>
    );
};

export default ChangePasswordModal;
